import UsersService from '@/services/users/users-service'
import UserInvitesService from '@/services/users/user-invites-service'
import { alertSuccess } from '@/utilities/sweetalert'

export const state = {
  users: [],
  user: {},
  loading: {
    users: false,
    invitationLoading: null,
    resendLoadingID: null
  }
}

export const getters = {
  users: state => state.users,
  user: state => state.user,
  loading: state => state.loading
}

export const actions = {
  fetchUsers({ commit }) {
    commit('SET_USERS_LOADING', true)

    UsersService.index()
      .then(response => {
        commit('SET_USERS', response.data)
      })
      .catch(() => {
        commit('SET_USERS', [])
      })
      .then(() => {
        commit('SET_USERS_LOADING', false)
      })
  },

  deleteUser({ commit }, id) {
    commit('SET_USERS_LOADING', true)

    UsersService.delete(id)
      .then(() => {
        commit('REMOVE_USER', id)
        commit('REMOVE_USER_FROM_USERS', id)

        alertSuccess({
          title: 'User successfully deleted.'
        })
      })
      .catch(() => {
        //
      })
      .then(() => {
        commit('SET_USERS_LOADING', false)
      })
  },

  inviteUser({ commit, dispatch }, payload) {
    commit('SET_USERS_LOADING', true)

    UserInvitesService.store(payload)
      .then(response => {
        if (response.data.project_id) {
          dispatch('projects/fetchProject', response.data.project_id, {
            root: true
          })
        }

        alertSuccess({
          title: 'User invite successfully sent.'
        })
      })
      .catch(() => {})
      .then(() => {
        commit('SET_USERS_LOADING', false)
      })
  }

  //   resendInvite({ commit, dispatch }, id) {
  //     commit('SET_RESEND_LOADING_ID', id),
  //       axios
  //         .patch(`/api/user_invites/${id}`)
  //         .then(response => {
  //           mixins.methods.showAlert('Invite successfully resent.', 'success')
  //           commit('SET_STATUS', response.status)

  //           if (response.data.project_id && response.data.role_id) {
  //             dispatch('projects/fetchProject', response.data.project_id, {
  //               root: true
  //             })
  //           }
  //         })
  //         .catch(error => {
  //           mixins.methods.showAlert(
  //             error.response.data.message,
  //             'error',
  //             error.response.data.errors
  //           )
  //         })
  //         .then(() => {
  //           commit('SET_RESEND_LOADING_ID', null)
  //         })
  //   },
  //   cancelInvite({ commit, dispatch }, payload) {
  //     commit('SET_INVITATION_LOADING', payload.id)

  //     axios
  //       .delete(`/api/user_invites/${payload.id}`)
  //       .then(response => {
  //         mixins.methods.showAlert(
  //           'Invitation successfully cancelled.',
  //           'success'
  //         )
  //         commit('SET_STATUS', response.status)

  //         if (payload.project_id) {
  //           dispatch('projects/fetchProject', payload.project_id, { root: true })
  //         }
  //       })
  //       .catch(error => {
  //         mixins.methods.showAlert(
  //           error.response.data.message,
  //           'error',
  //           error.response.data.errors
  //         )
  //       })
  //       .then(() => {
  //         commit('SET_INVITATION_LOADING', null)
  //       })
  //   }

  // fetchUser({ commit }, id) {
  //     commit('SET_LOADING', true)

  //     axios.get(`/api/users/${id}`)
  //         .then(response => {
  //             commit('SET_STATUS', response.status)
  //             commit('SET_USER', response.data)
  //         })
  //         .catch(error => {
  //             commit('SET_STATUS', error.response.status)
  //             commit('SET_USER', {})
  //         })
  //         .then(() => {
  //             commit('SET_LOADING', false)
  //         })
  // },
  // storeUser({ commit }, payload) {
  //     commit('SET_LOADING', true)

  //     axios.post('/api/users/', {
  //             name: payload.name,
  //             email: payload.email,
  //             phone: payload.phone,
  //             wiki: payload.wiki
  //         })
  //         .then(response => {
  //             mixins.methods.showAlert('Project successfully saved.', 'success')
  //             commit('SET_USERS', response.data)
  //         })
  //         .catch(error => {
  //             mixins.methods.showAlert(error.response.data.message, 'error', error.response.data.errors)
  //         })
  //         .then(() => {
  //             commit('SET_LOADING', false)
  //         })
  // },
  // updateUser({ commit }, payload) {
  //     commit('SET_LOADING', true)

  //     axios.patch(`/api/users/${payload.id}`, {
  //             name: payload.name,
  //             email: payload.email,
  //             phone: payload.phone,
  //             wiki: payload.wiki
  //         })
  //         .then(response => {
  //             mixins.methods.showAlert('Project successfully updated.', 'success')
  //             commit('SET_USER', response.data)
  //         })
  //         .catch(error => {
  //             mixins.methods.showAlert(error.response.data.message, 'error', error.response.data.errors)
  //         })
  //         .then(() => {
  //             commit('SET_LOADING', false)
  //         })
  // }
}

export const mutations = {
  SET_USERS(state, users) {
    state.users = users
  },
  SET_USERS_LOADING(state, loading) {
    state.loading.users = loading
  },
  REMOVE_USER_FROM_USERS(state, id) {
    if (!state.users || !state.users.length) return

    state.users = state.users.filter(user => user.id !== id)
  },
  REMOVE_USER(state, id) {
    if (!state.user && state.user.id !== id) return

    state.user = {}
  },
  INSERT_USER_TO_USERS(state, user) {
    state.users.push(user)
  }
}
